module.exports = __webpack_public_path__ + "img/meron.bfdb214f.svg";